<template >

  <v-row no-gutters
    class="background-submenu-mobile">
    <v-col>
      <v-list>

        <div class="title-submenu" v-if="menu.children2">
          {{ menu.children[0].title }}
        </div>

        <v-list-item link tile
          v-for="(submenu, index) in menu.children" :key="index" 
            :to="submenu.path">
    
            <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon>
      
            <v-list-item-content> 
              <v-list-item-title class="subtitle-2 pl-5">
                  {{ submenu.name }}
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

<!--         <v-list-item link tile
          v-for="(submenu, index) in menu.children2" :key="index" 
            :to="submenu.path">
    
            <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon>
      
            <v-list-item-content> 
              <v-list-item-title class="subtitle-2 pl-5">
                  {{ submenu.name }}
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item link tile
          v-for="(submenu, index) in menu.children3" :key="index" 
            :to="submenu.path">
    
            <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon>
      
            <v-list-item-content> 
              <v-list-item-title class="subtitle-2 pl-5">
                  {{ submenu.name }}
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-col>
    <v-col v-if="menu.children2">
      <v-list>

        <div class="title-submenu" v-if="menu.children2">
          {{ menu.children2[0].title }}
        </div>
      
        <v-list-item link
          v-for="(submenu2, index) in menu.children2" :key="index" 
            :to="submenu2.path">
            
          <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon>

          <v-list-item-content> 
            <v-list-item-title class="subtitle-2 pl-5">
                {{ submenu2.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-col>
    <v-col v-if="menu.children3">
      <v-list>

        <div class="title-submenu" v-if="menu.children3">
          {{ menu.children3[0].title }}
        </div>
        <v-list-item link
          v-for="(submenu2, index) in menu.children3" :key="index" 
            :to="submenu2.path">

          <v-icon size="15" class="icon-submenu" :color="menu.color">mdi-rhombus-medium</v-icon>

          <v-list-item-content>
            <v-list-item-title class="subtitle-2 pl-5">
                {{ submenu2.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'SubmenuMobile',
  props: [
    'menu'
  ],
  methods: {
  },
  computed: {
    routes () {
      return this.$store.getters.routes
    }
  }
};
</script>

<style scoped lang="scss">
.column-menu {
    flex-flow: column wrap !important;
    font-size: .65em;
    width: max-content;
    min-width: auto;
    position: absolute;
    background: white;
    padding-top: 20px;
    padding-bottom: 40px;
    border-radius: 0 0 22px 10px;
    border:0;
    border-top: 5px solid rgb(92, 130, 253);
    background-image: linear-gradient(#c8e0fc, #c7fcf2);

    li {
      padding: 10px 25px 0px 0px;

      div {
        border-bottom: 3px solid transparent;
        padding: 6px 10px 4px;
        border-radius: 4px;
      }
      div:hover {
        color: rgb(60, 137, 253);
        cursor: pointer;
        background-color: rgb(255, 255, 255);
      }
    }
}
.background-submenu {
  background: white;
  border-radius: 0 !important;
}
.icon-submenu {
  margin-right: -15px !important;
  padding-right: 0 !important;
  width: 15px !important;
}

</style>